<template>
	<v-card
		rounded="lg"
		data-aos="fade-up"
		class="px-5 py-10"
		width="100%"
	>
		<div
			class="display-1 my-5 text-center"
		>
			Promo Code
		</div>
		<div
			class="display-5 mb-2 justify-center black--text font-weight-bold"
		>
			Enter your promo code here:
		</div>
    <v-text-field
      full-width
			v-model="code"
			outlined
			dense
			clearable
			autofocus
			@keyup.enter="getPromo"
			:error-messages="error"
    ></v-text-field>
		<div class="d-flex align-items-center my-5">
			<base-button
				name="Get Promo"
				color="#0e6ccd"
				block
				large
				@click="getPromo"
			></base-button>
		</div>
	</v-card>
</template>

<script>
	import Repository from "@/api/repositories"
	const ShopPromotionPlansApi = Repository.get("shopPromotionPlans")

	export default {
		name: "PlanCodeCard",
		props: {
			//
		},
		data: () => ({
			code: '',
			error: '',
			plans: [],
			promoId: localStorage.getItem('promoId')
		}),
		methods: {
			async getPromo() {
				if (this.code) {
					const { data } = await ShopPromotionPlansApi.check(this.promoId, this.code);
					console.log(data.data.length, data.data, data)
					if (!data.data.id) {
						this.error = 'Invalid code!'
					}
					else {
						this.$store.commit('promoCart/setCurrentPlan', data.data)
						localStorage.setItem('promoPlan', JSON.stringify(data.data))
					}
				}
				else {
					this.error = 'This field is required.'
				}

				setTimeout(() => {
					this.error = ''
				}, 3000);
			},
		}
	}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables.scss";

.peso {
	font-family: Arial;
}

.label {
	font-size: 14px;
}

h1 {
	letter-spacing: 0.5px;
}
</style>